import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../authentication/auth.service';
import { UserDetailsService } from '../../services/user-details.service';

declare var $: any;

@Component({
  selector: 'app-customer-header',
  templateUrl: './customer-header.component.html',
  styleUrls: ['./customer-header.component.css'],
   providers: [UserDetailsService]
})
export class CustomerHeaderComponent implements OnInit {

  constructor(private authService: AuthService,public userDetailService: UserDetailsService,) {
  }

  ngOnInit() {
  
  }

  ngAfterViewChecked() {
    this.addClassActive();
  }

  logOut(): void {
    this.authService.logOut();
  }
  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }


  addClassActive() {
    if ($('.checkActive').hasClass('active')) {
      $('#Designs').removeClass('active');
    }
    else {
      $('#Designs').addClass('active');
    }
  }

  addClass() {
    $('#Designs').addClass('active');
  }

  removeClass() {
    $('#Designs').removeClass('active');
  }

}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/shared/customer-header/customer-header.component.ts